import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import HowItWorksPage from './pages/HowItWorksPage';
import BrowsePage from './pages/BrowsePage';
import PricingPage from './pages/PricingPage';
import FAQPage from './pages/FAQPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import DashboardFindPage from './pages/dashboard/DashboardFindPage';
import DashboardChatsPage from './pages/dashboard/DashboardChatsPage';
import DashboardBookingsPage from './pages/dashboard/DashboardBookingsPage';
import DashboardFavouritesPage from './pages/dashboard/DashboardFavouritesPage';
import DashboardAccountPage from './pages/dashboard/DashboardAccountPage';
import DashboardSettingsPage from './pages/dashboard/DashboardSettingsPage';
import DashboardProfilePage from './pages/dashboard/DashboardProfilePage';
import ProviderProfileViewPage from './pages/dashboard/ProviderProfileViewPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import FWBPage from './pages/FWBPage';
import OnboardingPage from './pages/OnboardingPage';
import RecreateProfilePage from './pages/RecreateProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './components/AdminLayout';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminUserDetailPage from './pages/admin/AdminUserDetailPage';
import AdminVerificationPage from './pages/admin/AdminVerificationPage';
import AdminFakeProfilesPage from './pages/admin/AdminFakeProfilesPage';
import AdminFakeProfileEditPage from './pages/admin/AdminFakeProfileEditPage';
import AdminFakeProfileChatsPage from './pages/admin/AdminFakeProfileChatsPage';
import AdminReportsPage from './pages/admin/AdminReportsPage';
import AuthHashRedirect from './components/AuthHashRedirect';

const Routes = () => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthHashRedirect />
      <RouterRoutes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/browse" element={<BrowsePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/payment" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
          <Route path="/fwb" element={<ProtectedRoute><FWBPage /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute requireProfileComplete={false}><OnboardingPage /></ProtectedRoute>} />
          <Route path="/onboarding/recreate-profile" element={<ProtectedRoute requireProfileComplete={false}><RecreateProfilePage /></ProtectedRoute>} />
        </Route>

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="find" element={<DashboardFindPage />} />
          <Route path="chats" element={<DashboardChatsPage />} />
          <Route path="bookings" element={<DashboardBookingsPage />} />
          <Route path="favourites" element={<DashboardFavouritesPage />} />
          <Route path="fwb" element={<FWBPage />} />
          <Route path="account" element={<DashboardAccountPage />} />
          <Route path="settings" element={<DashboardSettingsPage />} />
          <Route path="profile" element={<DashboardProfilePage />} />
          <Route path="profile/view/:userId" element={<ProviderProfileViewPage />} />
        </Route>

        <Route
          path="/admin"
          element={
            <ProtectedRoute requireProfileComplete={false}>
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboardPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="users/:userId" element={<AdminUserDetailPage />} />
          <Route path="verification" element={<AdminVerificationPage />} />
          <Route path="fake-profiles" element={<AdminFakeProfilesPage />} />
          <Route path="fake-profiles/:dummyId/edit" element={<AdminFakeProfileEditPage />} />
          <Route path="fake-profiles/:dummyId/chats" element={<AdminFakeProfileChatsPage />} />
          <Route path="reports" element={<AdminReportsPage />} />
        </Route>

        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </RouterRoutes>
    </BrowserRouter>
  );
};

export default Routes;
